module.exports = __webpack_public_path__ + "img/智慧应急综合预警研判系统.8ab0d01b.png";